import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { EnvelopeIcon, ArrowLeftIcon } from '@heroicons/react/20/solid';

import Input from '../../components/form-control/Input';
import Button from '../../components/form-control/Button';
import { SIGN_IN } from '../../resources/links';
import { toast } from 'react-toastify';
import Link from '../../components/Link';
import clsx from 'clsx';
import { forgotPassword } from '../../api/requests';
import useUserAccount from '../../hooks/stateHooks/userAccountHook';

function ForgotPassword() {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { signOut } = useUserAccount();

  useEffect(() => {
    signOut(false);
  }, [])

  return (
    <div
      className={clsx(
        ' bg-white mx-1 rounded-md py-16 md:mx-14 font-poppins w-full md:w-1/2 lg:w-1/3'
      )}>
      <h3 className='text-[30px] w-full text-center font-semibold'>Reset Password</h3>
      <p className="text-sm sm:text-base py-2 text-center  text-[#9CA3AF]">
        Enter your account email to request password reset
      </p>
      <Formik
        initialValues={{
          email: '',
          admin: true
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object({
          email: Yup.string().trim().email('Invalid email').required('Email is required')
        })}
        onSubmit={async (values) => {
          try {
            setSubmitting(true);

            const res = await forgotPassword(values.email);
            console.log("forgot password response", res);
            toast.success(res.message, {
              autoClose: 3000
            });
            setSubmitting(false);
          } catch (error: any) {
            setSubmitting(false)
            toast.error(`${error.message ?? error.detail}`, {
              autoClose: 3000
            });
          }
        }}>
        {({ values, errors, isSubmitting, handleSubmit, handleChange }) => (
          <form className="px-3 md:px-10 my-7" onSubmit={handleSubmit}>
            <div className="my-5">
              <Input
                label="Email"
                name="email"
                required
                wrapperClasses="my-5"
                value={values.email.toLowerCase()}
                prepend={<EnvelopeIcon className="w-6 h-6 text-gray-500" />}
                error={errors.email}
                onChange={handleChange}
                helperText={errors.email}
              />

              <Button
                type="submit"
                label="Submit"
                className="mt-5 flex justify-center rounded px-6 w-full bg-black text-white hover:text-white"
                loading={submitting}
                disabled={submitting}
              />

              <div className="text-center mt-10">
                <div className="text-sm flex gap-4 items-center justify-center py-1 sm:py-3">
                  <ArrowLeftIcon className="h-6 w-6 text-gray-600" />
                  <Link to={`/auth/${SIGN_IN}`} label="Back to Sign in" />
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default ForgotPassword;
